// extracted by mini-css-extract-plugin
module.exports = {"attendance-button":"attendance-button__3Pm8A","active":"active__31gGE","icon":"icon__3p5Pz","label":"label__2BhkM"};